// const fs = require("fs");
// const path = require("path");
// 引入当前文件夹下，不包含子目录，以js结束的所有js行程的上下文（模块）
// const context = require.context("./", false, /\.js$/);
// console.log(context.keys());

// context.keys().forEach(key => {
//   console.log(key);
//   const fileModule = context(key);
//   console.log(fileModule.default);
// })

/**
 * load file
 * @param {string} dir 文件夹物理路径
 * @param {*} cb
 */
function loader(context, cb) {
  let files = context.keys();

  files.forEach(filename => {
    let moduleName = filename.replace(/(\.\/|\.js)/g, "");
    let file = context(filename).default;

    cb(moduleName, file);
    // // cb(filename, file);
  });
}

/**
 * loader router
 * @param {class} app class
 */
function initRoutes(app) {
  let router = {};
  let context = require.context("./routes", false, /\.js$/);

  loader(context, (moduleName, file) => {
    const prefix = moduleName;

    // 遍历模块下的路由
    Object.keys(file).forEach(routeName => {
      let fullPath = prefix + "_" + routeName;
      if (!(fullPath in router)) {
        router[fullPath] = (...args) => {
          return file[routeName](app, ...args);
        };
      }
    });
  });

  return router;
}

function initController(app) {
  let controller = {};
  let context = require.context("./controller", false, /\.js$/);

  loader(context, (moduleName, file) => {
    controller[moduleName] = new file(app);
  });

  return controller;
}

function initService(app) {
  let service = {};
  let context = require.context("./service", false, /\.js$/);

  loader(context, (moduleName, file) => {
    service[moduleName] = new file(app);
  });

  return service;
}

function initModel(app) {
  let models = {};
  let context = require.context("./model", false, /\.js$/);

  loader(context, (moduleName, model) => {
    models[moduleName] = model(app);
  });

  return models;
}

export default { initRoutes, initController, initService, initModel };
